__turbopack_context__.v({
  "author": "ImageCopyright-module__NiW8Sa__author",
  "copyright": "ImageCopyright-module__NiW8Sa__copyright",
  "symbol": "ImageCopyright-module__NiW8Sa__symbol",
  "symbolBackground": "ImageCopyright-module__NiW8Sa__symbolBackground",
});
